import React, { Component } from 'react';
import './siteMap.css';
import Donate from '../donate/donate';
import Terms from '../terms/terms';
import News from '../news/news';
import Strategy from '../strategy/strategy'
import About from '../about/about'
import Resources from '../resources/resources'
import Contact from '../contact/contact'
import JoinList from '../join/joinlist'
import WsdeHold from '../strategy/wsde/wsdeHold'
import ClapbackChest from '../resources/awp/clapbacks'
import Screensaver from "./screensaver"
import { Link, Route, Switch } from 'react-router-dom';
 


var winWidth = window.innerWidth,
		winHeight = window.innerHeight




//console.log(winHeight, winWidth, currentScreen, mapArray[currentScreen-1]);

class Sitemap extends Component {
	constructor(props) {
		super(props);
		this.state = {
			menuActive: true,
			ticker:[],
			pic1: [],
			pic2: [],
			pic3:[],
			siteMap: false,
			currentScreen: 4,
			mobileMenu: false,
			mobileTop: 0,
			pageTitles:["BSA—About", "BSA—Mumbo Jumbo", "BSA—Resource Guide", "Black Socialists in America", "BSA—Our Strategy", "BSA—Contact", "BSA—Join Us", "BSA—Donate"],
			urlMatch:{"about": 1, "mumbo-jumbo": 2, "resource-guide": 3, "home": 4, "our-strategy": 5, "contact": 6, "join-us": 7, "donate": 8},
			mapVis: [0,0,0,1,0,0,0,0],
			mapArray: [0,((winWidth*-1)+(winWidth*.01)),((winWidth*-2)+(winWidth*.15)),((winWidth*-3)+(winWidth*.20))]                 
		};
	}

	updateDimensions() {
		winWidth = window.innerWidth;
		winHeight = window.innerHeight;

		if(window.innerWidth < 800){
			this.setState({mapArray: [0,((winWidth*-1)),((winWidth*-2)),((winWidth*-3)+(winWidth*.05))]}, () => {
				this.closeMenu()
				this.moveSection(this.state.currentScreen);
				
			})
			
			
		}
		else{
			this.setState({mapArray: [0,((winWidth*-1)+(winWidth*.02)),((winWidth*-2)+(winWidth*.15)),((winWidth*-3)+(winWidth*.20))]}, () => {
				this.closeMenu()
				this.moveSection(this.state.currentScreen);
				
			})
		}
		
		
		if(this.state.siteMap === true){
			this.moveSection(this.state.currentScreen)
			this.closeSiteMap();
		}
	}

	componentDidMount() {
		window.addEventListener("resize", this.updateDimensions.bind(this));
		var url = window.location.href;
		var currentSection = url.split('/')[3];
		
		if(!currentSection || (currentSection === "news") || (currentSection === "features")){
			currentSection = "home"
		} else if(currentSection ==="dual-power-map"){
			currentSection = "our-strategy"
		} else if(currentSection === "clapback-chest"){
			currentSection = "resource-guide"
		}

		var currentCall = (this.state.urlMatch[currentSection]);

		this.setState({currentScreen: currentCall},() => {
			this.updateDimensions();
		});
		this.sectionCheck();
		this.getStrat();
		this.getTicker();

		document.title = "BSA—Donate";
	}
		
	componentWillUnmount() {
		window.removeEventListener("resize", this.updateDimensions.bind(this));
	}
	
	mobileNavCheck(){
		if(!this.state.mobileMenu){
			this.openMenu();
		}
		else{
			this.closeMenu();
		};
	};

	sectionCheck(){
		var url = window.location.href;
		var currentSection =url.split('/')[3];
		if (!currentSection || (currentSection === "news") || (currentSection === "features")){
			currentSection = "sechome";
		}
		// else if(currentSection === "dual-power-map"){
		// 	currentSection = "secour-strategy"
		// }
		// else if(currentSection === "clapback-chest"){
		// 	currentSection = "secresource-guide"
		// }
		else{currentSection="sec"+currentSection;}
		var removeActive = document.getElementsByClassName('sectionActive');
		if(removeActive.length > 0){
			removeActive[0].classList.remove('sectionActive')
		}
		var newActive = document.getElementsByClassName(currentSection);
		if(newActive.length > 0){
			newActive[0].classList.add('sectionActive')
		}
	}

	openMenu(){
		this.setState({mobileMenu: true, mobileTop:window.innerHeight*.80}, () => {
										
		})
	}

	closeMenu(){
		this.setState({mobileMenu: false, mobileTop:0}, () => {
										
		})
	}

	siteMap(){
		if(this.state.siteMap===false){
			this.setState({siteMap: true});
			var tickerActive = document.getElementsByClassName('ticker-move')
			if(tickerActive.length > 0){
					tickerActive[0].classList.add('tickerActive')        }
			var mapActive = document.getElementsByClassName('mapActive')
			if(mapActive.length > 0){
					mapActive[0].classList.remove('mapActive')        }
			var mapHold = document.getElementsByClassName('mapHolder')
			if(mapHold.length > 0){
			mapHold[0].classList.add('siteMapActive')
			}
			this.refs.map.style.top= 20+"%";
			this.refs.map.style.left= this.state.mapArray[0]+"px";
		}
		else{
			this.moveSection(this.state.currentScreen)
			this.closeSiteMap();
		}
	}

	closeSiteMap(){
		this.setState({siteMap: false},()=>{
			var tickerActive = document.getElementsByClassName('tickerActive')
			if(tickerActive.length > 0){
				tickerActive[0].classList.remove('tickerActive')        }
			var mapHold = document.getElementsByClassName('siteMapActive')
			if(mapHold.length > 0){
				mapHold[0].classList.remove('siteMapActive')
			}
		})
	}

	hideMainNav=()=>{
		if(this.state.menuActive === true ){
				var menu= document.getElementById('desktopMenu')
				if(menu){
						menu.classList.add('activeDesktop')
						this.setState({menuActive: false})
				}

		}
	}

	showMainNav=()=>{
	
			if(this.state.menuActive === false){
					var menu= document.getElementById('desktopMenu')
					if(menu){
							menu.classList.remove('activeDesktop')
							this.setState({menuActive: true})
					}

			}

	}


	manualMap=(e)=> {
		console.log(e.currentTarget.dataset.id, 10)
		if(this.state.siteMap === true){
			this.closeSiteMap();
		}
		//currentScreen = this.
		if((parseInt(e.currentTarget.dataset.id, 10) !== this.state.currentScreen)) {
				this.moveSection((parseInt(e.currentTarget.dataset.id, 10)));
		}
		else{
				this.moveSection(this.state.currentScreen);
		}
	};

	moveSection(e) {
		if(this.state.mobileMenu === true){
			this.closeMenu();
		}
		var moveTo = e;
		var mapLink = "maplink"+e;
		document.title = this.state.pageTitles[e-1];
		var currentActiveDom = document.getElementsByClassName(mapLink);
		var previousMapLink = document.getElementsByClassName('mapActive');
		if(previousMapLink.length > 0){
			previousMapLink[0].classList.remove('mapActive');
		}
		if(currentActiveDom.length > 0){
			currentActiveDom[0].classList.add('mapActive')
		}
		let mapVis = [...this.state.mapVis];
		let newVis = mapVis.map((number)=> 0);
		newVis[moveTo-1] = 1;
		this.setState({
			currentScreen: moveTo,
			mapVis:newVis
		}, () => {
			if(moveTo <= 4) {
				this.refs.map.style.top= 0;
				this.refs.map.style.left= this.state.mapArray[moveTo-1]+"px";
			}
			else{
				if(window.innerWidth < 800){
					this.refs.map.style.top= ((-1*winHeight)+85)+"px";
				}
				else{
				this.refs.map.style.top= ((-1*winHeight)+(winHeight*.18))+"px";
				}
				this.refs.map.style.left= this.state.mapArray[moveTo-5]+"px";
			}
			this.sectionCheck();
			//   console.log(this.state.mapVis);
		});
	};

	getStrat = () => {
		fetch('/api/strategy')
		.then(res => res.json())
		.then(data=> this.setState({ pic1: data.pic1, pic2: data.pic2, pic3: data.pic3 }));
	}

	getTicker = () => {
		fetch('/api/dash')
		.then(res => res.json())
		.then(ticker=> this.setState({ ticker }));

	}

	prettyDate(dateString){
		var date = new Date(dateString);
		var d = date.getDate();
		var m = date.getMonth();
		var y = date.getFullYear();
		return d+'.'+m+'.'+y;
	}


	render() {

		const { mapArray } = this.state;
		const { ticker} = this.state;
		const { pic1 } = this.state;
		const { pic2 } = this.state;
		const { pic3 } = this.state;

		return (
			<React.Fragment>
			
			{window.innerWidth > 850 ? (
				<header id="desktopMenu" className="desktopMenu">
					<div className="leftLinks navBlock">
						<Link to='/about' onClick={this.manualMap.bind(this)} data-id="1" data-name="about"><div className="navLinks secabout" >about</div></Link>
						<Link to='/mumbo-jumbo' onClick={this.manualMap.bind(this)} data-id="2" data-name="mumbo-jumbo"><div className="navLinks secmumbo-jumbo" >mumbo jumbo</div></Link>
						<div className="secresource-guide">
							<Link to='/resource-guide' onClick={this.manualMap.bind(this)} data-id="3" data-name="resource-guide"><div className="navLinks secresource-guide">resources</div></Link>
							<Link to='/clapback-chest' onClick={this.manualMap.bind(this)} data-id="3" data-name="resource-guide"><div className="subMenuItem navLinks secresource-guide" >Clapback Chest</div></Link>
						</div>
						<Link to='/' onClick={this.manualMap.bind(this)} data-id="4" data-name="news"><div className="navLinks sechome" >news</div></Link>
					</div>
					<div className="navLogo navBlock bgCover" style={{backgroundImage: `url(/images/BSALogo.svg)`}}  onClick={this.siteMap.bind(this)}></div>
					<div className="rightLinks navBlock">
						<div className="secour-strategy" ><Link to='/our-strategy' onClick={this.manualMap.bind(this)} data-id="5" data-name="our-strategy"><div className="navLinks secour-strategy relativ" >our  strategy</div></Link><Link to='/dual-power-map' onClick={this.manualMap.bind(this)} data-id="5" data-name="our-strategy"><div className="subMenuItem navLinks secour-strategy" >Dual Power Map</div></Link></div>
						<Link to='/contact' onClick={this.manualMap.bind(this)} data-id="6" data-name="contact"><div className="navLinks seccontact" >contact</div></Link>
						<Link to='/join-us' onClick={this.manualMap.bind(this)} data-id="7" data-name="join-us"><div className="navLinks secjoin-us" >join us</div></Link>
						<Link to='/donate' onClick={this.manualMap.bind(this)} data-id="8" data-name="donate"><div className="navLinks secdonate">donate</div></Link>
					</div>
				</header>
			) : (
				<React.Fragment>
					<header className="phoneMenu">
						<div className="mobileMenu fullWidth relative">
							<div className="mobileLogo mobileBlock bgCover diffE" style={{backgroundImage: `url(/images/BSALogo.svg)`}}></div>
							<div className="mobileButton mobileBlock navLinks diffE" data-id="1" onClick={this.mobileNavCheck.bind(this)}>MENU</div>
						</div>
				 </header>
				 <div className="mobileNav bgRed fullWidth fullHeight grid" style={{"top" : -(winHeight*.05)}}>
						<div className="mobileLinkHold ">
							<div className="mobileLeftLinks navBlock mobile">
								<Link to='/about'><div className="navLinks mobile secabout" data-id="1" data-name="about" onClick={this.manualMap.bind(this)}>about</div></Link>
								<Link to='/mumbo-jumbo'><div className="navLinks  mobile secmumbo-jumbo" data-id="2" data-name="mumbo-jumbo" onClick={this.manualMap.bind(this)}>mumbo jumbo</div></Link>
								<Link to='/resource-guide'><div className="navLinks  mobile secresource-guide" data-id="3" data-name="resource-guide" onClick={this.manualMap.bind(this)}>resources</div></Link>
								<Link to='/clapback-chest'><div className="navLinks  mobile secclapback-chest" data-id="3" data-name="resource-guide" onClick={this.manualMap.bind(this)}>Clapback Chest</div></Link>
								<Link to='/'><div className="navLinks  mobile sechome" data-id="4" data-name="news" onClick={this.manualMap.bind(this)}>news</div></Link>
							</div>
							<div className="mobileRightLinks navBlock mobile">
								<Link to='/our-strategy'><div className="navLinks  mobile secour-strategy" data-id="5" data-name="our-strategy" onClick={this.manualMap.bind(this)}>our  strategy</div></Link>
								<Link to='/dual-power-map'><div className="navLinks  mobile secdual-power-map" data-id="5" data-name="our-strategy" onClick={this.manualMap.bind(this)}>Dual Power Map</div></Link>
								<Link to='/contact'><div className="navLinks  mobile seccontact" data-id="6" data-name="contact" onClick={this.manualMap.bind(this)}>contact</div></Link>
								<Link to='/join-us'><div className="navLinks  mobile secjoin-us" data-id="7" data-name="join-us" onClick={this.manualMap.bind(this)}>join us</div></Link>
								<Link to='/donate'><div className="navLinks  mobile secdonate" data-id="8" data-name="donate" onClick={this.manualMap.bind(this)}>donate</div></Link>
							</div>
						</div>
					</div>
				</React.Fragment> 
			)}
				
			<div className="saverStage bgBlack hiddenSaver" style={{"height" : winHeight, "width" : winWidth}}>
				<Route path='/' render={()=><Screensaver/>} />
			</div>
				
			<div className="viewFinder" style={{"height" : winHeight, "width" : winWidth, "top": this.state.mobileTop}}>
				<div id="mapHolder" className="mapHolder" ref="map" style={{"height" : (winHeight*2), "width" : (winWidth*4), "left":(mapArray[3]+"px")}}>
					<div className="mapResources mapBlocks wT bgWhite" style={{"height" : winHeight, "width" : (winWidth*4)}}>
						<div className ="mapItem map1 aboutView bgBlack" data-id="1" data-name="about">
							<Link className="mapLink  maplink1" to='/about'  data-id="1" data-name="about"onClick={this.manualMap.bind(this)}></Link>
							<h5 className="headerHuge centerT marginBotLarge marginTopHuge fullStage upperT bgBlack">Who<br/>we<br/>are</h5>
							<Route exact path='/about' render={()=><About parentMove={this.manualMap} mapVis={this.state.mapVis}/>} />
						</div>
						<div id="termFull" className ="Case mapItem map2 blkT bgOffWhite" data-id="2" data-name="mumbo-jumbo" >
							<Link className="mapLink maplink2" to='/mumbo-jumbo' onClick={this.manualMap.bind(this)} data-id="2" data-name="mumbo-jumbo"></Link>
							<div className="fullStage marginBotMed marginTopStart">
								<p className="termsStage boldT upperT marginBotSmall oneColumnPush titleFont termsStart">THE BSA GLOSSARY OF</p>
								<h1 className="termsStage oneColumnPush">So<span className="redT redDot">•</span>cial<span className="redT redDot">•</span>ist <br/>Terms</h1>
							</div>
							<Route exact path='/mumbo-jumbo' render={()=><Terms mapVis={this.state.mapVis}/>} />
						</div>
						<div className ="mapItem map3 bgOffWhite" data-id="3" data-name="resources">
							<Link className="mapLink  maplink3" to='/resource-guide' onClick={this.manualMap.bind(this)} data-id="3" data-name="resource-guide"></Link>
							<div className=" resourceHold fullStage bgBlack">  
								<h1 className="oneColumnPush paddingTopStart marginBotMed">Resource <br/>Guide</h1>
								<Switch>
									<Route path='/clapback-chest' render={()=><ClapbackChest mapVis={this.state.mapVis}/>} />    
									<Route path='/resource-guide' render={()=><Resources mapVis={this.state.mapVis}/>} />
								</Switch>
							</div>
						</div>
						<div className ="mapItem map4 bgBlack" data-id="4" data-name="news" >
							<Link className="mapLink  maplink4" to='/' onClick={this.manualMap.bind(this)} data-id="4" data-name="news"></Link>
							<News />
						</div>
					</div>
					<div className="mapActions mapBlocks wT bgRed" style={{"height" : winHeight, "width" : (winWidth*4)}}>
						<div id="stratSec" className ="mapItem map5 bgBlack" data-id="5" data-name="our-strategy" >
							<Link className="mapLink maplink5" to='/our-strategy' onClick={this.manualMap.bind(this)} data-id="5" data-name="our-strategy"></Link>
							<h5 className="stratHead upperT centerT marginTopLarge tfStage marginBotLarge">Our<br/>Strategy</h5>
							<div className="partnerLogos fullStage flexBox marginBotLarge">
								{pic1.length ? (
									<img alt="cjLogo" className="partnerLogo cjLogo" src={pic1[0].imgURL} >
									</img>
								):(
									<div>
										<h2>No logo found</h2>
									</div> 
								)}
								{pic2.length ? (
									<img alt="bsaLogo" className="partnerLogo" src={pic2[0].imgURL} >
									</img>
								):(
									<div>
										<h2>No logo found</h2>
									</div> 
								)}
								{pic3.length ? (
									<img alt="symLogo" className="partnerLogo symLogo" src={pic3[0].imgURL} >
									</img>
								):(
									<div>
										<h2>No logo found</h2>
									</div> 
								)}
							</div>
							<Switch>
									<Route path='/dual-power-map' render={()=><WsdeHold hideNav={this.hideMainNav} showNav={this.showMainNav} mapVis={this.state.mapVis}/>} />    
									<Route exact path='/our-strategy' render={()=><Strategy mapVis={this.state.mapVis}/>} />
							</Switch>
						</div>
						<div className ="mapItem map6 blkT" data-id="6" data-name="contact" >
							<Link className="mapLink  maplink6" to='/contact' onClick={this.manualMap.bind(this)} data-id="6" data-name="contact"></Link>
							<Route path='/' render={()=><Contact mapVis={this.state.mapVis}/>} />
						</div>
						<div className ="mapItem map7 relative" data-id="7" data-name="join">
							<Link className="mapLink  maplink7" to='/join-us' onClick={this.manualMap.bind(this)} data-id="7" data-name="join-us"></Link>
							<div className="joinHeader fullWidth fullHeight">
								<div className="joinHeadHold fullStage centeredContent">
									<h5 className="upperT centerT joinHead">Join</h5>
									<h5 className="upperT centerT joinHead">Now</h5>
									<p className="centerT tfStage resourceTitle boldT upperT marginTopMed blink titleFont">Scroll down to start</p>
								</div>
								<Route path='/join-us' render={()=><JoinList mapVis={this.state.mapVis}/>} />
							</div>
						</div>
						<div className ="mapItem map8 blkT" data-id="8" data-name="donate">
						{!this.state.siteMap && (this.state.currentScreen===8)?(''):(
							<Link className="mapLink  maplink8" to='/donate' onClick={this.manualMap.bind(this)} data-id="8" data-name="donate"></Link>
							)}
							<div className="donateHC">
								<h6 className="donateHeader upperT marginTopLarge">Donate to BSA</h6>
							</div>
							<Route path='/' render={()=><Donate manualMap={this.manualMap} mapVis={this.state.mapVis}/>} />
						</div>
					</div>
				</div>
				<div className="tickerHolder wT">
					{ticker.length ? (
						<React.Fragment>
							<div className="ticker-wrap blinkFast">
								<div className="ticker-move">
									{ticker.map((item, i) => {
										return(
											<div className="singleTicker titleFont" key={i}>
												<p><span className="upperT numeroText ">{"("+this.prettyDate(item.updated_at)+")"}</span><span className="titleFont upperT">{item.dashTitle+": "}</span>{item.copy}</p>
											</div>
										)
									})}
								</div>
							</div>
						</React.Fragment>
					):(
						<div className="fullWidth fullHeight redT blinkFast loader">
							<div className="centeredContent">•</div>
						</div>
					)}
				</div>
				<div className="legalCopy wT">© 2020 Black Socialists in America, a 501(c)(3) organization</div>
			</div>
			</React.Fragment>
		);
	}
}

export default Sitemap;



// WEBPACK FOOTER //
// ./src/components/sitemap/siteMap.js